import { useState, useEffect } from 'react';

export enum THEMES {
  light = 'light',
  dark = 'dark'
}

/**
 * WARNING:Do not use this directly! Use useTheme() instead, this is for internal use only
 *
 * Toggles dark mode
 * It adds a 'dark' as a class to the document that is then used by tailwind.
 * It also stores it in the localStorage
 *
 */
export function useDarkMode(): [string, () => void] {
  const [theme, setTheme] = useState(
    () => localStorage.getItem('theme') ?? THEMES.light
  );

  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.documentElement.classList.toggle(
      THEMES.dark,
      theme === THEMES.dark
    );
  }, [theme]);

  function toggleDarkMode(): void {
    setTheme((prevTheme) =>
      prevTheme === THEMES.dark ? THEMES.light : THEMES.dark
    );
  }

  return [theme, toggleDarkMode];
}
